import { useEffect, useState } from "react";

import { Avatar } from "./Avatar";
import styles from "./TypingIndicator.module.css";

// Shown while AERO is thinking but hasn't started typing yet. If the server
// tells us what it's doing (e.g. a web search) we show that; otherwise we
// rotate through a few reassuring lines so a long pause never feels stuck.
const FALLBACK_STEPS = [
  "AERO is thinking…",
  "Working on your recommendation…",
  "Almost there — putting it together…",
];

export function TypingIndicator({ status }: { status?: string | null }) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (status) return; // server-driven label wins; no rotation
    setStep(0);
    const id = setInterval(
      () => setStep((s) => Math.min(s + 1, FALLBACK_STEPS.length - 1)),
      2800,
    );
    return () => clearInterval(id);
  }, [status]);

  const label = status ?? FALLBACK_STEPS[step];

  return (
    <div className={styles.row} aria-live="polite" aria-label={label}>
      <Avatar size={28} />
      <div className={styles.bubble}>
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.label}>{label}</span>
      </div>
    </div>
  );
}
